import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App, { preloadInitialPage } from './App';

const rootElement = document.getElementById('root');

const tree = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// `react-snap` writes a fully rendered HTML snapshot for every route at build
// time so non-JS crawlers (GPTBot, PerplexityBot, ClaudeBot, Bingbot, social
// unfurlers) receive real content and JSON-LD instead of an empty shell.
// When that markup is present we hydrate it; otherwise we render from scratch.
if (rootElement.hasChildNodes()) {
  // The route's page component is code-split, so its chunk must be in memory
  // before the first render — otherwise React renders the Suspense fallback
  // over the prerendered content, sees a mismatch, and throws the snapshot
  // away. Awaiting the chunk first is what makes hydration actually reuse the
  // prerendered DOM.
  preloadInitialPage()
    .catch(() => {})
    .then(() => ReactDOM.hydrateRoot(rootElement, tree));
} else {
  ReactDOM.createRoot(rootElement).render(tree);
}
